<template>
    <div class="imageIdentify" v-loading="loading" element-loading-text="正在加载中">
        <div class="top">
            <!-- <changeName></changeName>
      <imageName></imageName> -->
        </div>
        <div class="contentBill" style="height: calc(100% - 55px);">
            <!-- true 不允许更换单证 -->
            <template v-if="$route.query.status === 'true'">
                <div class="upload-demo">
                    <!-- <el-button size="small" class="cancel" type="white disable" style="height:42px;line-height: 42px;">更换模板文件</el-button> -->
                </div>
            </template>
            <template v-else>
                <TestUploadFile></TestUploadFile>
            </template>
            <div class="toTest">
                <!-- <el-button size="small" type="test" @click="testTemplate">测试模板</el-button> -->
            </div>
            <bl-drag :id="bgDragId" :draggable="false">
                <div slot="left-content" class="left">
                    <ImageDocRender v-loading="areaLoading" ref="imageRender"></ImageDocRender>
                </div>
                <div slot="right-content" class="right doc-set" id="rightSroll" style="overflow-y:auto">

                    <el-tabs v-model="activeName" @tab-click="tabClick" class="tabsTop">
                        <el-tab-pane :lazy="true" name="first" key="first">
                            <span slot="label"><em>1</em>单证分类配置</span>
                            <el-form label-width="190px" ref="cateForm" label-position="right" class="demo-ruleForm">
                                <el-form-item label="单证类型" prop="category" style="margin-bottom: 5px;" required>
                                    <el-input v-model="category" disabled></el-input>
                                    <ihelp class="tooltips1 tooltips2" helpName="单证类型"></ihelp>
                                </el-form-item>
                                <el-form-item label="" style="margin-bottom: 5px;">
                                    <div slot="label" style="position: relative">
                                        <span class="label">单证类型分类分数阈值</span>
                                        <ihelp class="tooltips1" helpName="单证类型分类分数阈值"></ihelp>
                                    </div>
                                    <el-select v-model="priority" style="width: 100%" disabled>
                                        <el-option v-for="item in priorityOptions" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <div class="tabs-auto">
                                <h3>单证主类型关键字配置</h3>
                                <el-button style="height: 35px;" type="primary" size="small" @click="addTab()">
                                    + 添加关键字规则
                                </el-button>
                            </div>
                            <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab">
                                <el-tab-pane v-for="(item,index) in editableTabs" :key="index.toString()"
                                    :label="'规则'+(index+1)" :name="index.toString()">
                                    <el-form :model="item" ref="ruleForm" label-width="190px" label-position="right"
                                        class="demo-ruleForm">
                                        <el-form-item label="单证类型关键字" style="margin-bottom: 5px;" class="selectMul">
                                            <createSelect style="width: 100%" v-model="item.contentList"
                                                keyName="contentList" type="category" @on-input="inputRuleForm">
                                            </createSelect>
                                            <ihelp class="tooltips1 tooltips2" helpName="单证类型关键字"></ihelp>
                                        </el-form-item>
                                        <el-form-item label="单证类型关键字格式" style="margin-bottom: 5px;" class="selectMul">
                                            <createSelect style="width: 100%" v-model="item.valueFormatList"
                                                keyName="valueFormatList" type="category" @on-input="inputRuleForm">
                                            </createSelect>
                                            <ihelp class="tooltips1 tooltips2" helpName="单证类型关键字格式"></ihelp>
                                        </el-form-item>
                                        <el-form-item label="关键字所在行区间" style="margin-bottom: 5px;position: relative;">
                                            <div style="display: flex; height: 32px;">
                                                <el-input placeholder="" v-model="item.beginRow" type="number"
                                                    @blur="numBlur('beginCol')">
                                                    <template slot="prepend">第</template>
                                                    <template slot="append">行</template>
                                                </el-input>
                                                <div style="color: #666;margin: 0 10px;">至</div>
                                                <el-input placeholder="" v-model="item.endRow" type="number"
                                                    @blur="numBlur('beginRow')">
                                                    <template slot="prepend">第</template>
                                                    <template slot="append">行</template>
                                                </el-input>
                                            </div>
                                            <ihelp class="tooltips1 tooltips2" helpName="关键字所在行区间"></ihelp>
                                        </el-form-item>
                                        <!-- <el-form-item label="关键字所在行具体位置" style="margin-bottom: 5px;">
                  <el-tooltip class="tooltips1" effect="dark" content="" placement="right">
                    <i class="icon icon-help"></i>
                  </el-tooltip>
                  <el-select v-model="position" style="width: 100%" clearable>
                    <el-option v-for="item in positionArr" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item> -->
                                        <el-form-item label="关键字所在区域" style="margin-bottom: 5px;">
                                            <el-select v-model="item.areas" clearable multiple placeholder="请选择位置（多选）"
                                                style="width: 100%;">
                                                <el-option v-for="(item,index) in areasOptions"
                                                    :key="item.value + index" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <ihelp class="tooltips1 tooltips2" helpName="关键字所在区域"></ihelp>
                                        </el-form-item>
                                        <el-form-item label="不能包含的关键字" style="margin-bottom: 5px;" class="selectMul">
                                            <createSelect style="width: 100%" v-model="item.noContainList"
                                                keyName="noContainList" type="category" @on-input="inputRuleForm">
                                            </createSelect>
                                            <ihelp class="tooltips1 tooltips2" helpName="不能包含的关键字"></ihelp>
                                        </el-form-item>
                                        <!-- <el-form-item label="不能包含关键字所在行区间" style="margin-bottom: 5px;">
                  <el-tooltip class="tooltips1" effect="dark" content="" placement="right">
                    <i class="icon icon-help"></i>
                  </el-tooltip>
                  <div style="display: flex; height: 32px;">
                    <el-input placeholder="" v-model="item.endCol" type="number" @blur="numBlur('endCol')">
                      <template slot="prepend">第</template>
                      <template slot="append">行</template>
                    </el-input>
                    <div style="color: #666;margin: 0 10px;">至</div>
                    <el-input placeholder="" v-model="item.endRow" type="number" @blur="numBlur('endRow')">
                      <template slot="prepend">第</template>
                      <template slot="append">行</template>
                    </el-input>
                  </div>
                </el-form-item> -->
                                        <el-form-item label="关键字规则组得分" style="margin-bottom: 5px;position: relative;">
                                            <div slot="label" style="position: relative">
                                                <span class="label">关键字规则组得分</span>
                                                <ihelp class="tooltips1" helpName="关键字规则组得分"></ihelp>
                                            </div>
                                            <el-select v-model="item.weight" style="width: 100%">
                                                <el-option v-for="item in priorityOptions" :key="item" :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-form>
                                </el-tab-pane>
                            </el-tabs>
                            <div class="tabs-auto">
                                <h3>文件分页配置</h3>
                            </div>
                            <el-form label-width="190px" label-position="right" class="demo-ruleForm" style="border: 0">
                                <el-form-item label="页码关键字" prop="name" style="margin-bottom: 5px;" class="selectMul">
                                    <createSelect style="width: 100%" v-model="pageContentList"
                                        keyName="pageContentList" type="category" @on-input="inputForm"></createSelect>
                                    <ihelp class="tooltips1 tooltips2" helpName="页码关键字"></ihelp>
                                </el-form-item>
                                <el-form-item label="页码关键字格式" prop="name" style="margin-bottom: 5px;" class="selectMul">
                                    <createSelect style="width: 100%" v-model="pagevalueFormatList"
                                        keyName="pagevalueFormatList" type="category" @on-input="inputForm">
                                    </createSelect>
                                    <ihelp class="tooltips1 tooltips2" helpName="页码关键字格式"></ihelp>
                                </el-form-item>
                            </el-form>
                            <div class="tabs-auto">
                                <h3></h3>
                                <el-button type="primary" class="subBtn" @click="saveFn('cateForm')">确定并保存</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="字段配置" :lazy="true" name="four" key="four">
                            <span slot="label"><em>2</em>字段配置</span>
                        </el-tab-pane>
                        <el-tab-pane :label="editType === null? 'OCR识别结果':'文件解析结果'" :lazy="true" name="third"
                            key="third">
                            <span slot="label"><em>3</em>{{editType === null? 'OCR识别结果':'文件解析结果'}}</span></el-tab-pane>
                    </el-tabs>
                    <!-- third OCR识别结果 -->
                    <ocrResult v-if="activeName ==='third'"></ocrResult>
                    <filedConfig v-if="activeName ==='four'" :subObj="subObj"></filedConfig>
                </div>
            </bl-drag>
        </div>
        <!-- 抽屉组件 -->
        <Drawer></Drawer>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import Drawer from '../../common/Drawer'

    import _ from 'lodash'

    import TestUploadFile from './TestUploadFile'
    import ImageDocRender from './ImageDocRender'
    import BlDrag from '../../common/bl-drag'
    import changeName from '../../common/changeName'
    import imageName from '../../common/imageName'
    import ocrResult from '../../common/ocrResultConf'
    import DocFields from './DocFields'
    import DocType from './DocType'
    import filedConfig from './filedConfig'
    import createSelect from '../../common/createSelect'
    import ihelp from '../../common/ihelp'

    export default {
        name: 'editContent',
        mixins: [],
        props: {},
        data() {
            return {
                activeName: 'first',
                mainInfo: [],
                bgDragId: '',
                subTypeRule: {},
                loading: false,
                areaLoading: false,
                ruleForm: {},
                editableTabsValue: '0',
                editableTabs: [],
                rules: {
                    category: [
                        {
                            required: true,
                            message: '请填写单证类型名称',
                            trigger: ['blur', 'change']
                        },
                        {
                            min: 2,
                            max: 30,
                            message: '长度在2-30个字符以内',
                            trigger: ['blur', 'change']
                        }
                    ]
                },
                tabIndex: 1,
                category: this.$route.query.name,
                priorityOptions: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0, -100, -200, -300],
                priority: '6',
                positionArr: [
                    {
                        label: '左边1/3',
                        value: 1
                    },
                    {
                        label: '中央',
                        value: 2
                    },
                    {
                        label: '右边1/3',
                        value: 3
                    }
                ],
                position: '',
                areasOptions: [
                    {
                        value: 'UP',
                        label: '上方'
                    },
                    {
                        value: 'DOWN',
                        label: '下方'
                    },
                    {
                        value: 'LEFT',
                        label: '左边'
                    },
                    {
                        value: 'RIGHT',
                        label: '右边'
                    },
                    {
                        value: 'UP_LEFT',
                        label: '左上方'
                    },
                    {
                        value: 'UP_RIGHT',
                        label: '右上方'
                    },
                    {
                        value: 'DOWN_LEFT',
                        label: '左下方'
                    },
                    {
                        value: 'DOWN_RIGHT',
                        label: '右下方'
                    },
                    {
                        value: 'LEFT_THIRD',
                        label: '左边1/3'
                    },
                    {
                        value: 'RIGHT_THIRD',
                        label: '右边1/3'
                    }
                ],
                areas: [],
                input1: '',
                pageContentList: [],
                pagevalueFormatList: [],
                subObj: {}
            }
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters(['editTemplate', 'editType', 'tabOCRName'])
        },
        watch: {
            editTemplate(val) {
                if (val) {
                    //console.log(val)
                    /*
                     *   category: "df"  默认单证类型-默认为创建模板名字，修改命名后为subTypeRule.category
                     *   imageList: Array 图片列表
                     *   ruleMap: Object，规则
                     *   subTypeRule: Object 单证分类配置
                     *   templateId: "5fbf9c36f24250199f022f66" 模板id
                     */
                    // this.subTypeRule = val.subTypeRule
                    // this.$nextTick().then(() => this.setData(val))
                    this.subObj = Object.assign({}, val.commonClassifyConfigDo)
                    this.pageContentList =
                        val.commonClassifyConfigDo ? val.commonClassifyConfigDo.pageRule.contentList : []
                    this.pagevalueFormatList =
                        val.commonClassifyConfigDo ? val.commonClassifyConfigDo.pageRule.valueFormatList : []
                    if (val.commonClassifyConfigDo.ruleList.length > 0) {
                        this.editableTabs = val.commonClassifyConfigDo.ruleList
                    } else {
                        this.editableTabs = [
                            {
                                contentList: [],
                                noContainList: [],
                                valueFormatList: [],
                                areas: [],
                                weight: 6
                            }
                        ]
                    }
                }
            }
        },
        mounted() {
            // this.init()
        },
        updated() { },
        beforeDestroy() {
            //清除滚动位置 DocFields.vue
            localStorage.removeItem('BL_ORIGIN_TEMPLATE_EDITTEXTSCROLL')

            //清除折叠位置 editCollapse.vue
            localStorage.removeItem('BL_ORIGIN_TEMPLATE_COLLAPSE')
        },
        methods: {
            init() {
                let url = this.$resource.getClassifyRuleInfo.replace(
                    '{caId}',
                    this.$route.query.id
                )
                this.$axios({
                    url: url,
                    method: 'get'
                })
                    .then(res => {
                        let data = res && res.data.data
                        //console.log(data.commonClassifyConfigDo.ruleList, 'ruleList')
                        if (data.commonClassifyConfigDo.ruleList.length > 0) {
                            this.editableTabs = data.commonClassifyConfigDo.ruleList
                        } else {
                            this.editableTabs = [
                                {
                                    contentList: [],
                                    noContainList: [],
                                    valueFormatList: [],
                                    areas: [],
                                    weight: 6
                                }
                            ]
                        }
                    })
                    .catch(e => { })
            },
            addTab() {
                let num = this.editableTabs.length.toString()
                //console.log(this.editableTabs.length)
                this.editableTabs.push({
                    contentList: [],
                    noContainList: [],
                    valueFormatList: [],
                    areas: [],
                    weight: 6
                })
                //console.log(this.editableTabsValue)
                this.editableTabsValue = num
                //console.log(this.editableTabsValue)
            },
            removeTab(targetName) {
                if (this.editableTabs.length === 1) {
                    return this.$message.error('至少有一条规则')
                }
                let tabs = this.editableTabs
                this.editableTabs = tabs.filter(
                    (tab, index) => index.toString() !== targetName
                )
                if (targetName > this.editableTabsValue) {
                    ///不做处理
                } else if (this.editableTabsValue === targetName) {
                    this.editableTabsValue = '0'
                } else {
                    this.editableTabsValue = (this.editableTabsValue - 1).toString()
                }
            },
            deleteSuccess(x) {
                let index = this.mainInfo.findIndex(item => {
                    return item[0] === x
                })
                this.mainInfo.splice(index, 1)
            },
            setData(val) {
                // 改造mainInfo，=>DocFields.vue=>editCollapse.vue引入
                let entries = Object.entries(val.ruleMap)
                entries.forEach(item => {
                    // 获取规则
                    // console.log(item)

                    // item[0]：存储字段名

                    // item[1]：存储编辑规则内容-与默认值合并
                    //初始化后端表单undefined的属性
                    if (item[1]['fieldRuleList'].length === 0) {
                        let x = _.cloneDeep(this.$utils.defaultRule)
                        x.name = item[0]
                        item[1]['fieldRuleList'] = [x]
                    } else {
                        item[1]['fieldRuleList'].forEach(x => {
                            x = _.defaults(x, this.$utils.defaultRule)
                        })
                        item[1]['fieldRuleList'] = _.cloneDeep(item[1]['fieldRuleList'])
                    }

                    // 筛选规则
                    let fieldFilterRule = _.defaults(
                        item[1]['fieldFilterRule'],
                        this.$utils.defaultFilterRule
                    )

                    item[1]['fieldFilterRule'] = _.cloneDeep(fieldFilterRule)

                    //item[2]：存储新增tabs属性
                    item.push({
                        _editableTabs: [],
                        _editableTabsValue: '1', //tabs,v-model
                        _tablen: item[1]['fieldRuleList'].length //tabs长度
                    })

                    //item[2]：_editableTabs新增属性
                    item[1]['fieldRuleList'].forEach((x, i) => {
                        /*
                         * title: '规则1',饿了吗组件字段
                         * name: '1',饿了吗组件字段
                         * validator: true 校验
                         *
                         */
                        let obj = {}
                        obj.result = true
                        obj.validator = true

                        //tab属性
                        let num = i + 1
                        obj.title = '规则' + num
                        obj.name = '' + num

                        item[2]['_editableTabs'].push(obj)
                    })

                    //item[3]：新增测试，存储抽取结果属性
                    item.push({
                        _edited: false, // 折叠开关，true代表当前折叠展开
                        _huoqu: true, // 折叠开关，true代表值的获取展开
                        _shaixuan: false, // 折叠开关，true代表值的筛选展开
                        _testShow: false, //结果展示开关
                        _testWord: '', //测试结果：单值，rectangle字段赋值
                        _rectangleList: [], //测试结果，多值，rectangleList字段赋值
                        _sourceData: [] //抽取结果，sourceData字段赋值
                    })
                })
                this.mainInfo = _.cloneDeep(entries)
            },
            tabClick(tabInstance) {
                //tab切换后，自动定位到当前正在配置的字段
                let editScroll = this.$utils.storage('BL_ORIGIN_TEMPLATE_EDITTEXTSCROLL')
                if (tabInstance.name === 'second' && editScroll) {
                    //切换到第二个tab,先展开collage,然后延时滚动
                    setTimeout(() => {
                        let editTexts = document.querySelector('.editTexts')
                        if (editTexts) {
                            editTexts.scrollTop = editScroll
                        }
                    }, 500)
                }

                // 当前tab名为原文件，清空标注框及文字
                if (this.tabOCRName === '原文件') {
                    this.$text && this.$text.setData([])
                    this.$polygon && this.$polygon.setData([])
                }
            },
            testTemplate() {
                let id = this.$route.query.id
                let url = this.$resource.getTemplateInfo.replace('{id}', id)

                this.$axios({
                    // url: 'http://localhost:8080/data.json',
                    url: url,
                    method: 'get'
                })
                    .then(res => {
                        let data = res.data.data

                        // 校验
                        if (data.subTypeRule && data.subTypeRule.containWords.length > 0) {
                            let query = this.$route.query

                            this.$router.push({
                                path: '/dashboard/template/testpage',
                                query: {
                                    id: query.id,
                                    name: query.name,
                                    ruleId: query.ruleId,
                                    from: this.$route.name,
                                    category: query.category,
                                    status: String(this.$route.query.status),
                                    certiType: this.$route.query.certiType
                                }
                            })
                        } else {
                            this.$message.error('单证类型标识未配置')
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            inputForm(key, value) {
                this[key] = value
            },
            inputRuleForm(key, value) {
                this.editableTabs[this.editableTabsValue][key] = value
            },
            saveFn(formName) {
                if (!this.category) {
                    return this.$message.error('请输入单证类型')
                }
                //console.log(this.editableTabs, '上传参数')
                this.$axios({
                    url: this.$resource.editClassifyRule.replace(
                        '{ruleId}',
                        this.$route.query.ruleId
                    ),
                    method: 'PUT',
                    data: {
                        category: this.category,
                        pageRule: {
                            contentList: this.pageContentList,
                            valueFormatList: this.pagevalueFormatList
                        },
                        ruleId: this.$route.query.ruleId,
                        categoryId: this.$route.query.id,
                        ruleList: this.editableTabs
                    }
                }).then(res => {
                    this.$message.success('保存成功！')
                })
            },
            numBlur(key) {
                if (this.editableTabs[this.editableTabsValue][key] > 999) {
                    this.editableTabs[this.editableTabsValue][key] = ''
                }
            }
        },
        components: {
            BlDrag,
            changeName,
            TestUploadFile,
            ImageDocRender,
            ocrResult,
            DocType,
            DocFields,
            imageName,
            createSelect,
            ihelp,
            Drawer,
            filedConfig
        }
    }
</script>
<style>
    #rightSroll {
        padding: 10px !important;

        .el-tabs__item {
            em {
                background: #f1f8ff;
                width: 18px;
                height: 18px;
                line-height: 18px;
                color: #8399c4;
                border-radius: 50%;
                display: inline-block;
                text-align: center;
                font-size: 12px;
                margin-right: 10px;
            }
        }

        .el-tabs__item.is-active {
            em {
                background: #4580fe;
                width: 18px;
                height: 18px;
                line-height: 18px;
                color: #fff;
                border-radius: 50%;
                display: inline-block;
                text-align: center;
                font-size: 12px;
                margin-right: 10px;
            }
        }
    }

    #tab-second {
        /* border-right: 1px solid #eee; */
    }

    #tab-third {
        /* padding-left: 50px; */
    }

    .demo-ruleForm {}

    .tabs-auto {
        margin-bottom: 5px;
        margin: 10px;
        display: flex;
        justify-content: space-between;

        h3 {
            color: #7b7b7b;
            font-weight: 600;
        }
    }

    .subBtn {
        background: var(--color-title);
        border: 1px solid var(--color-title);
        border-radius: 5px;
        font-size: 14px;
        color: #fff;
        padding: 4px 10px;
        line-height: 1;
        width: 130px;
        background: #3d7fff;
        font-size: 16px;
        color: #fff;
        height: 36px;
        line-height: 36px;
        padding: 0;
        border-radius: 4px;
        font-weight: normal;
        /*display: flex;
        align-items: center;
        justify-content: center;*/

        .icon-create {
            margin-right: 8px;
        }
    }

    .tooltips1 {
        position: absolute;
        right: 0;
        margin-top: 13px;
        z-index: 1;
        color: #666;
        cursor: pointer;
    }
</style>